import { useDispatch, useSelector } from 'react-redux';
import { Button, Container, Dialog, DialogTitle } from '@mui/material';
import * as CommonActions from '../../redux/actions/commonAction';

const DescriptionModal = () => {
    const dispatch = useDispatch();
    const { descriptionModalIsOpen, descriptionModalData } = useSelector(state => state?.commonReducer);

    return (
        <Dialog open={descriptionModalIsOpen} onClose={() => dispatch(CommonActions?.closeDescriptionModal())} PaperProps={{ sx: { maxWidth: { xs: '90vw', sm: '50vw' }, minWidth: { xs: '90vw', sm: '50vw' } } }}>
            <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                <div>{descriptionModalData?.title}</div>
                <Button onClick={() => dispatch(CommonActions?.closeDescriptionModal())}>Cancel</Button>
            </DialogTitle>

            {descriptionModalData?.type == 'editor' && <Container sx={{ paddingBottom: "50px" }}>
                <div dangerouslySetInnerHTML={{ __html: descriptionModalData?.text }}></div>
            </Container>}

            {!descriptionModalData?.type && <Container sx={{ paddingBottom: "50px" }}>
                <div style={{ textAlign: 'justify' }}>{descriptionModalData?.text}</div>
            </Container>}
        </Dialog>
    )
}

export default DescriptionModal;